import { DRButton } from './DRControls';
import './Dialog.scss';

interface DialogProps {
  title?: string;
  text?: string;
  primaryButtonText?: string;
  primaryButtonColor?: string;
  primaryButtonWidth?: number;
  clickPrimaryButton?: () => void;
  secondaryButtonText?: string;
  secondaryButtonColor?: string;
  secondaryButtonWidth?: number;
  clickSecondaryButton?: () => void;
  showOverlay?: boolean;
}

export default function Dialog({
  title,
  text,
  primaryButtonText,
  clickPrimaryButton,
  secondaryButtonText,
  clickSecondaryButton,
  showOverlay = true,
  primaryButtonColor,
  secondaryButtonColor,
  primaryButtonWidth,
  secondaryButtonWidth,
}: DialogProps) {
  const renderButtons = () => {
    let buttons = [];

    if (secondaryButtonText && clickSecondaryButton) {
      buttons.push(
        <DRButton
          key="secondary-button"
          phrase={secondaryButtonText || ''}
          fillColor="transparent"
          borderColor={secondaryButtonColor || ''}
          fontColor={secondaryButtonColor || ''}
          action={clickSecondaryButton}
          fontSize={24}
          height={52}
          width={secondaryButtonWidth}
        />,
      );
    }

    if (primaryButtonText && clickPrimaryButton) {
      buttons.push(
        <DRButton
          key="primary-button"
          phrase={primaryButtonText || ''}
          fillColor="transparent"
          borderColor={primaryButtonColor || ''}
          fontColor={primaryButtonColor || ''}
          action={clickPrimaryButton}
          fontSize={24}
          height={52}
          width={primaryButtonWidth}
        />,
      );
    }

    if (buttons.length) {
      return buttons;
    }
    return null;
  };

  return (
    <div className="dialog" role="dialog">
      <div className="dialog__body">
        {title && (
          <div className="dialog__title" role="heading" aria-level={1}>
            {title}
          </div>
        )}
        {text && (
          <div className="dialog__text" role="paragraph">
            {text}
          </div>
        )}
        <div className="dialog__footer">{renderButtons()}</div>
      </div>
      {showOverlay && <div className="dialog__overlay" role="presentation"></div>}
    </div>
  );
}
